<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="cash-stack" class="mr-2"></b-icon>Kassa Hisoboti (joriy holat)</h2>
        </div>
        <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading">
          <b-icon icon="arrow-repeat"></b-icon> Yangilash
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Holat sanasi</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
      </div>

      <div class="rp-summary rp-summary-3">
        <div class="rp-card rp-c-1">
          <div class="rp-card-label">JAMI BALANS</div>
          <div class="rp-card-value">{{ fmt(totalBalance) }}</div>
        </div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">PAY TURLAR SONI</div>
          <div class="rp-card-value">{{ balances.length }}</div>
        </div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">DOLLAR BALANSI</div>
          <div class="rp-card-value rp-green">${{ fmt(dollarBalance) }}</div>
        </div>
      </div>

      <div class="rp-2col">
        <div class="rp-chart-wrap" v-if="balances.length > 0">
          <h3 class="rp-block-title"><b-icon icon="pie-chart-fill"></b-icon> Tuzilma</h3>
          <apexchart type="donut" height="280" :options="donutOptions" :series="donutSeries"></apexchart>
        </div>

        <div class="rp-section">
          <h3 class="rp-block-title"><b-icon icon="wallet"></b-icon> Pay turlari balansi</h3>
          <div class="rp-table-wrap">
            <table class="rp-table">
              <thead>
                <tr>
                  <th>Pay turi</th>
                  <th class="t-right">Jami kirim</th>
                  <th class="t-right">Jami chiqim</th>
                  <th class="t-right">Balans</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in balances" :key="r.pay_type_id">
                  <td class="rp-strong">{{ r.pay_type_name }} <span v-if="r.pay_type_id === 3" class="rp-badge-dollar">$</span></td>
                  <td class="t-right rp-green">{{ fmt(r.total_in) }}</td>
                  <td class="t-right rp-red">{{ fmt(r.total_out) }}</td>
                  <td class="t-right rp-strong" :class="r.balance >= 0 ? 'rp-green' : 'rp-red'">{{ fmt(r.balance) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="rp-section" v-if="bySklad.length > 0">
        <h3 class="rp-block-title"><b-icon icon="building"></b-icon> Sklad kesimida</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead><tr><th>Sklad</th><th class="t-right">Balans</th></tr></thead>
            <tbody>
              <tr v-for="r in bySklad" :key="r.sklad_id">
                <td class="rp-strong">{{ r.sklad_name || '—' }}</td>
                <td class="t-right rp-strong" :class="r.balance >= 0 ? 'rp-green' : 'rp-red'">{{ fmt(r.balance) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    return {
      date2: this.todayStr(),
      sklad_id: null,
      skladList: [],
      balances: [], bySklad: [], totalBalance: 0,
      loading: false,
    };
  },
  computed: {
    dollarBalance() {
      const d = this.balances.find(b => b.pay_type_id === 3);
      return d ? parseFloat(d.balance) || 0 : 0;
    },
    donutOptions() {
      return {
        chart: { fontFamily: 'inherit' },
        labels: this.balances.map(b => b.pay_type_name),
        colors: ['#16a34a', '#2563eb', '#10b981', '#a142f4', '#f59e0b', '#06b6d4'],
        legend: { position: 'bottom' },
        plotOptions: { pie: { donut: { size: '60%' } } },
        dataLabels: { enabled: true, formatter: v => v.toFixed(1) + '%' }
      };
    },
    donutSeries() { return this.balances.map(b => Math.abs(parseFloat(b.balance) || 0)); }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    todayStr() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, end = false) { return Math.floor(new Date(s + (end ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) { this.skladList = []; } },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/kassa-summary/', {
          datetime1: this.toUnix(this.date2, false),
          datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        this.balances = r.data.balances || [];
        this.bySklad = r.data.by_sklad || [];
        this.totalBalance = parseFloat(r.data.total_balance) || 0;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    }
  }
};
</script>
